import { render } from "./AdminBookings.vue?vue&type=template&id=689cd249&ts=true&lang=pug"
import script from "./AdminBookings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBookings.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__